import { IS_TEMPORARY_FREE_MODE_ENABLED } from '@/constants/freeMode';
import { UserTariffPlanEnum } from '@/types';
import type { UserModel } from '@/types';

type UserWithTariffPlan = Pick<UserModel, 'tariffPlan'>;

export const shouldRestrictByTariffPlan = (tariffPlanName?: UserTariffPlanEnum | null): boolean => {
  if (IS_TEMPORARY_FREE_MODE_ENABLED) {
    return false;
  }

  return tariffPlanName === UserTariffPlanEnum.Free;
};

export const shouldRestrictByTariff = (user?: UserWithTariffPlan | null): boolean =>
  shouldRestrictByTariffPlan(user?.tariffPlan?.name);

export const shouldShowBillingUi = (): boolean => !IS_TEMPORARY_FREE_MODE_ENABLED;

export const shouldLoadBillingData = (): boolean => shouldShowBillingUi();
